/* ============================================================
   Lumière — Quiet Luxury theme
   assets/theme.js  (vanilla, no dependencies)
   ============================================================ */
(function () {
  "use strict";

  var root = document.documentElement;
  var body = document.body;

  /* ---------- Drawers (menu / search / cart) ---------- */
  var openDrawer = null;

  function drawerOpen(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) drawerClose(openDrawer);
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    body.classList.add("is-locked");
    openDrawer = el;
    if (el.id === "CartDrawer") loadCartRecommendations(el);
    var focusable = el.querySelector("[data-drawer-focus], button, a, input");
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  function drawerClose(el) {
    if (!el) return;
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    body.classList.remove("is-locked");
    if (openDrawer === el) openDrawer = null;
  }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-drawer-open]");
    if (opener) {
      e.preventDefault();
      drawerOpen(document.getElementById(opener.getAttribute("data-drawer-open")));
      return;
    }
    var closer = e.target.closest("[data-drawer-close]");
    if (closer) {
      e.preventDefault();
      drawerClose(closer.closest(".drawer"));
      return;
    }
    if (e.target.classList && e.target.classList.contains("drawer__scrim")) {
      drawerClose(e.target.closest(".drawer"));
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && openDrawer) drawerClose(openDrawer);
  });

  /* ---------- Scroll reveal ---------- */
  var revealables = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealables.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ---------- Header height variable ---------- */
  function syncHeaderHeight() {
    var header = document.querySelector(".header");
    if (header) root.style.setProperty("--header-h", header.offsetHeight + "px");
  }
  syncHeaderHeight();
  window.addEventListener("resize", syncHeaderHeight);

  /* ---------- Product gallery ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-src");
        var srcset = thumb.getAttribute("data-srcset");
        if (main && src) {
          main.src = src;
          if (srcset) main.srcset = srcset;
          main.alt = thumb.getAttribute("data-alt") || main.alt;
        }
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
          t.classList.toggle("is-active", t === thumb);
        });
      });
    });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll("[data-variant-form]").forEach(function (form) {
    var data = form.querySelector("[data-variant-json]");
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }

    var idInput = form.querySelector("[data-variant-id]");
    var priceEl = form.querySelector("[data-variant-price]");
    var submitEl = form.querySelector("[data-variant-submit]");
    var skuEl = form.querySelector("[data-variant-sku]");
    var moneyFormat = form.getAttribute("data-money-format") || "¥{{amount_no_decimals}}";

    function money(cents) {
      var amount = (cents / 100);
      var noDecimals = Math.round(amount).toLocaleString("ja-JP");
      var withDecimals = amount.toFixed(2);
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, withDecimals);
    }

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll("[data-option-index]").forEach(function (group) {
        var checked = group.querySelector("input:checked");
        var select = group.querySelector("select");
        if (checked) opts[parseInt(group.getAttribute("data-option-index"), 10)] = checked.value;
        else if (select) opts[parseInt(group.getAttribute("data-option-index"), 10)] = select.value;
      });
      return opts;
    }

    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });

      form.querySelectorAll(".option__value").forEach(function (label) {
        var input = label.querySelector("input");
        if (input) label.classList.toggle("is-selected", input.checked);
      });

      if (!match) {
        if (submitEl) {
          submitEl.setAttribute("disabled", "disabled");
          submitEl.querySelector("span").textContent = submitEl.getAttribute("data-unavailable") || "Unavailable";
        }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (skuEl) skuEl.textContent = match.sku || "";

      if (priceEl) {
        var html = '<span class="price__now' + (match.compare_at_price > match.price ? " price__now--sale" : "") + '">' + money(match.price) + "</span>";
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<span class="price__was">' + money(match.compare_at_price) + "</span>";
        }
        priceEl.innerHTML = html;
      }

      if (submitEl) {
        var label = submitEl.querySelector("span");
        if (match.available) {
          submitEl.removeAttribute("disabled");
          label.textContent = submitEl.getAttribute("data-add") || "Add to cart";
        } else {
          submitEl.setAttribute("disabled", "disabled");
          label.textContent = submitEl.getAttribute("data-soldout") || "Sold out";
        }
      }

      if (match.featured_image && match.featured_image.src) {
        var main = form.closest(".product") && form.closest(".product").querySelector("[data-gallery-main]");
        if (main) main.src = match.featured_image.src;
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", match.id);
        history.replaceState({}, "", url.toString());
      }
    }

    form.addEventListener("change", update);
    update();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty]");
    if (!btn) return;
    var wrap = btn.closest(".qty");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var step = btn.getAttribute("data-qty") === "up" ? 1 : -1;
    var next = Math.max(parseInt(input.getAttribute("min") || "1", 10), (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- Cart drawer + AJAX add ---------- */
  var cartDrawer = document.getElementById("CartDrawer");
  function cartRequest(path, payload) {
    return fetch(window.Theme.routes.cart + path, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error("cart_update_failed");
      return response.json();
    });
  }

  function removeLegacySupport() {
    return fetch(window.Theme.routes.cart + ".js", { credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var support = cart.items.find(function (item) { return item.variant_id === 50586028441762; });
        if (!support) return false;
        return cartRequest("/change.js", { id: support.key, quantity: 0 }).then(function () { return true; });
      });
  }

  function loadCartRecommendations(drawer) {
    var slot = drawer && drawer.querySelector("[data-shine-cart-recommendations-slot]");
    if (!slot || slot.dataset.loading === "true" || slot.dataset.loaded === "true") return;
    var productId = slot.dataset.productId;
    if (!productId) return;
    slot.dataset.loading = "true";
    var localeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    var url = localeRoot + "recommendations/products?section_id=cart-drawer-recommendations&product_id=" + encodeURIComponent(productId) + "&limit=10&intent=related";
    fetch(url, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("recommendations_failed");
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var recommendations = doc.querySelector("[data-shine-cart-recommendations]");
        if (!recommendations || !recommendations.querySelector(".shine-cart-reco__item")) {
          slot.remove();
          return;
        }
        slot.innerHTML = recommendations.outerHTML;
        slot.dataset.loaded = "true";
      })
      .catch(function () { slot.remove(); });
  }

  function refreshCart() {
    if (!cartDrawer) { window.location.reload(); return; }
    return fetch(window.Theme.routes.cart + "?section_id=cart-drawer")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-cart-contents]");
        var current = cartDrawer.querySelector("[data-cart-contents]");
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          if (cartDrawer.classList.contains("is-open")) loadCartRecommendations(cartDrawer);
        }
        return fetch(window.Theme.routes.cart + ".js");
      })
      .then(function (r) { return r && r.json(); })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "" : "none";
        });
      });
  }

  window.ShineCart = { refresh: refreshCart };

  removeLegacySupport().then(function (changed) {
    if (!changed) return;
    if (body.classList.contains("template-cart")) window.location.reload();
    else refreshCart();
  }).catch(function () {});

  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !cartDrawer) return;
    e.preventDefault();
    var btn = form.querySelector("[data-variant-submit]");
    if (btn) btn.setAttribute("aria-disabled", "true");
    fetch(window.Theme.routes.cart_add, {
      method: "POST",
      headers: { Accept: "application/javascript" },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCart();
        drawerOpen(cartDrawer);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.removeAttribute("aria-disabled"); });
  });

  document.addEventListener("click", function (e) {
    var add = e.target.closest("[data-cart-recommend-add]");
    if (!add) return;
    e.preventDefault();
    var card = add.closest("[data-cart-recommend-card]");
    var variant = card && card.querySelector("[data-cart-recommend-variant]");
    var variantId = Number(variant ? variant.value : add.getAttribute("data-cart-recommend-add"));
    if (!variantId || add.disabled) return;
    add.disabled = true;
    cartRequest("/add.js", { items: [{ id: variantId, quantity: 1 }] })
      .then(function () { return refreshCart(); })
      .catch(function () {
        add.textContent = add.getAttribute("data-cart-recommend-error") || add.textContent;
        add.disabled = false;
      });
  });

  document.addEventListener("click", function (e) {
    var remove = e.target.closest("[data-cart-remove]");
    if (!remove) return;
    e.preventDefault();
    fetch(window.Theme.routes.cart_change, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: remove.getAttribute("data-cart-remove"), quantity: 0 })
    }).then(function () {
      if (document.body.classList.contains("template-cart")) window.location.reload();
      else refreshCart();
    });
  });

  /* ---------- Sort / filter auto-submit ---------- */
  document.querySelectorAll("[data-auto-submit]").forEach(function (el) {
    el.addEventListener("change", function () {
      var form = el.closest("form");
      if (form) form.submit();
    });
  });

  /* ---------- Marquee duplication ---------- */
  document.querySelectorAll("[data-marquee]").forEach(function (track) {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });
})();
